import { Link } from "react-router-dom";
import { ArrowRight, LineChart } from "lucide-react";
import { Reveal } from "./Reveal";

const ResearchCard = () => (
  <section className="bg-white dark:bg-brand-ink py-20 md:py-24" data-testid="research-highlight-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-slate-100 dark:border-white/10 bg-gradient-to-br from-brand-sky-soft via-white to-white dark:from-[#0D1434] dark:via-brand-ink dark:to-brand-ink p-10 md:p-16 shadow-[0_30px_80px_-40px_rgba(42,49,146,0.3)]">
          <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-brand-sky/15 blur-3xl" />
          <div className="relative grid md:grid-cols-[auto_1fr] gap-10 items-start">
            <div className="hidden md:flex w-16 h-16 rounded-2xl bg-brand-navy dark:bg-brand-sky items-center justify-center shrink-0">
              <LineChart size={26} className="text-white dark:text-brand-ink" />
            </div>
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-sky mb-4">Cost Comparison</p>
              <h3 className="font-display text-2xl md:text-4xl font-semibold tracking-tight text-slate-900 dark:text-white leading-tight max-w-3xl" data-testid="research-card-headline">
                Virtual Scribes Can <span className="text-brand-gradient">Significantly Reduce Staffing Costs</span> Compared
                With In-Person Scribes
              </h3>
              <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 dark:text-slate-300">
                Same expert trained scribes. Same real-time documentation inside your EHR. Potential savings may reach
                $15K–$30K+ annually depending on coverage, staffing structure, and local employment costs.
              </p>
              <Link
                to="/resources/virtual-vs-in-person-cost"
                data-testid="research-read-more-link"
                className="group mt-7 inline-flex items-center gap-2 text-sm font-bold text-brand-navy dark:text-brand-sky"
              >
                Read More
                <ArrowRight size={16} className="group-hover:translate-x-1.5 transition-transform duration-300" />
              </Link>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
export default ResearchCard;
